<div class="multiselect-dropdown" [class.disabled]="disabled">
  <div class="dropdown-header" tabindex="0" >
    <div class="search-input-container"  >
      <input type="text"
            
             [(ngModel)]="searchTerm"
             placeholder="{{showDropDown ? 'Search' : 'Select'}} {{ placeholder }}"
             (focus)="showFocus()"
             (click)="$event.stopPropagation()"
             (ngModelChange)="onSearchTermChange($event)"
             [style.padding-left.px]="showDropDown ? 25 : 0">
      <i class="fa fa-search search-icon" *ngIf="showDropDown || searchTerm"></i>
    </div>
    <span class="arrow" [class.arrow-up]="showDropDown" (click)="toggleDropDown()"></span>
  </div>

  <!-- Chips for selected items -->
  <div class="chips-container" *ngIf="selectedItems.length > 0">
    <span class="chip" *ngFor="let item of selectedItems" (click)="$event.stopPropagation()">
      {{ item[displayKey] }}
      <i class="fa fa-times remove-icon" (click)="removeSelectedItem(item, $event)"></i>
    </span>
  </div>

  <div class="dropdown-list" *ngIf="showDropDown">
    <ul>
      <li class="select-all" *ngIf="filteredList.length > 0">
        <input type="checkbox" [disabled]="disabled" [checked]="isAllSelected()" [indeterminate]="isIndeterminate()" (change)="toggleAllSelection($event)">
        <span>Select All</span>
      </li>
      <li *ngFor="let item of filteredList">
        <input type="checkbox" [disabled]="disabled" [checked]="isSelected(item)" (change)="onCheckboxChange(item, $event)">
        <span>{{ item[displayKey] }}</span>
      </li>
      <li *ngIf="filteredList.length === 0" class="no-results">No results found.</li>
    </ul>
  </div>
</div>
